// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__ZDx8y","tableGeneral":"ReportsTable_tableGeneral__TP9SV","tableGeneralHeader":"ReportsTable_tableGeneralHeader__hHHLl"};